module.exports = __webpack_public_path__ + "img/morse-and-vail.366deadd.png";